import React from "react";
import useApp from "../../store/app/appContext";
import useQuery from "../../hooks/useQuery";
import PageWrapper from '../../containers/app/PageWrapper';
import AppointmentsProvider from "../../store/appointments/appointmentsProvider";
import MyNotifications from "../../containers/home/MyNotifications";
import UpcomingAppointmentsCard from "../../containers/home/UpcomingAppointments";
import OngoingTreatments from '../../containers/home/OngoingTreatments'
import PendingPayments from '../../containers/home/PendingPayments'
import TreatmentsProvider from "../../store/treatments/treatmentsProvider";
import useWindowSize from "../../hooks/useWindowSize";
import AccountVerifiedModal from '../../containers/modals/AccountVerifiedModal';

function MainPage() {
  const { appState: { user, userAccount }} = useApp();

  const query = useQuery();

  const verified = query.get('verified');

  const windowSize = useWindowSize();

  if (!user) return '';
  if (!user._id) return '';
  
  return (
      <AppointmentsProvider>
        <TreatmentsProvider>
          <PageWrapper title={`Hi ${user.first_name},`} subtitle='Welcome back' navbar>
            {verified && <AccountVerifiedModal />}
            <div className='flex flex-col space-y-4 md:space-y-0 xl:flex-row h-full xl:space-x-4'>
              <div className='flex-grow' style={{ minHeight: '600px'}}>
                <MyNotifications />
              </div>
              {!userAccount.isRoot && 
              <div className='flex flex-col md:pt-4 xl:pt-0 md:flex-row xl:flex-col space-y-4 space-x-0 md:space-x-4 md:space-y-0 xl:space-x-0 xl:space-y-4 ' style={{ height: windowSize.width <= windowSize.tailwind.xl ? '400px' : '100%'}}>
                {userAccount.isPatientOrPartner && <UpcomingAppointmentsCard />}
                {userAccount.isPartner && <OngoingTreatments />}
                {userAccount.isPatient && <PendingPayments />}
              </div>
              }
            </div>
          </PageWrapper>
        </TreatmentsProvider>
      </AppointmentsProvider>
  );
}

export default MainPage;